import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import DocumentsExportHistoryContainer from 'features/document/edit/documents/components/DocumentsExportHistoryContainer';
import { Dialog } from '@totalsoft/rocket-ui';
import { BackdropCustom, DialogButton, DialogTitle } from './DocumentsStyles';

const DocumentsHistory = ({ fileId, open, onCloseModal }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='export-documents-history-dialog'
      open={open}
      onClose={onCloseModal}
      fullWidth={true}
      maxWidth={'lg'}
      BackdropComponent={BackdropCustom}
      transitionDuration={0}
      scroll='body'
      showX={false}
      disableBackdropClick
      disableEscapeKeyDown
      actionsProps={{ sx: theme => ({ px: theme.spacing(3), pb: theme.spacing(2) }) }}
      title={<DialogTitle>{t('OfferEdit.Documents.History.Title')}</DialogTitle>}
      content={<DocumentsExportHistoryContainer fileId={fileId} isForExport={true} />}
      actions={
        <DialogButton id={'commissionsCard_subsidiesModal_closeBtn'} color='primary' variant='contained' onClick={onCloseModal}>
          {t('Close')}
        </DialogButton>
      }
    />
  );
};

DocumentsHistory.propTypes = {
  fileId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired

};

export default DocumentsHistory;
